export function TShirtIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 56"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M22 4 L8 10 L2 22 L12 30 L18 26 L18 52 L46 52 L46 26 L52 30 L62 22 L56 10 L42 4 L40 8 Q32 16 24 8 Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
